<template>
    <div id="dashboard" class="container pt-5 pb-5 page">
        <transition name="fade" mode="out-in">
            <div class="row"  v-if="isParent">
                <div class="col-md-8">
                    <h2>Dashboard</h2>
                    <div class="mb-5 mt-5">
                        <h4>Nieuwe opdrachten</h4>
                        <new-assignments></new-assignments>
                    </div>
                    <h4>Snelkoppelingen</h4>
                    <div class="row">
                        <div class="col-md-4">
                            <card>
                                <h5 slot="title" class="uppercase mb-4">Pasmanager</h5>
                                <div slot="content">
                                    <router-link tag="button" class="btn btn-lg btn-outline-azure" :to="{ name: 'ProfessionalProfilePassManager'}">
                                        <span>Direct naar de pasmanager</span>
                                        <div class="btn-icon">
                                            <span>&rarr;</span>
                                        </div>
                                    </router-link>
                                </div>
                            </card>
                        </div>
                        <div class="col-md-4">
                            <card>
                                <h5 slot="title" class="uppercase mb-4">Pas aanvragen</h5>
                                <div slot="content">
                                    <router-link tag="button" class="btn btn-lg btn-outline-azure" :to="{ name: 'ProfessionalProfilePassRequest'}">
                                        <span>Digitaal een pas aanvragen</span>
                                        <div class="btn-icon">
                                            <span>&rarr;</span>
                                        </div>
                                    </router-link>
                                </div>
                            </card>
                        </div>
                        <div class="col-md-4">
                            <card>
                                <h5 slot="title" class="uppercase mb-4">Uw Tarieven</h5>
                                <div slot="content">
                                    <router-link tag="button" class="btn btn-lg btn-outline-azure" :to="{ name: 'ProfessionalProfileRates'}">
                                        <span>Uw tarieven instellen</span>
                                        <div class="btn-icon">
                                            <span>&rarr;</span>
                                        </div>
                                    </router-link>
                                </div>
                            </card>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card text-center">
                        <div class="card-body">
                            <div class="text-center vert-center">
                                <img :src="profileImage" class="img-fluid img-thumbnail rounded-circle img-profile mx-auto" />
                            </div>
                            <h3 class="mt-5 mb-5">{{user.firstName}} {{user.lastName}}</h3>
                            <div class="alert alert-success" role="alert" v-if="status == 2">
                                <strong>Goedgekeurd!</strong>
                            </div>
                            <div class="alert alert-warning" role="alert" v-else-if="status == 1">
                                <strong>In afwachting van goedkeuring!</strong>
                            </div>
                            <div class="alert alert-danger" role="alert" v-else-if="status == 3">
                                <strong>Afgekeurd!</strong>.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <router-view v-else></router-view>
        </transition>
    </div>
</template>

<script>
import NewAssignments from '@/components/NewAssignments';
import Card from '@/components/Card';
export default {
    components: {
        NewAssignments,
        Card
    },
    computed: {
        isParent() {
            if(this.$route.name.toLowerCase() == "professionaldashboard" || this.$route.name.toLowerCase() == "professional")
                return true;
            return false;
        },
        user() {
            return this.$store.getters.user;
        },
        profileImage() {
            if(this.user)
                return "data:" + this.user.profileImage.fileContentType + ";base64," + this.user.profileImage.file;
            return null;
        },
        status() {
            return this.user.profileStatusId;
        }
    }
}
</script>

<style scoped>
.img-profile {
    width: 75%;
}
</style>